// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsertRowLeftOutlinedSvg from "@fishx/icons-svg/es/asn/InsertRowLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var InsertRowLeftOutlined = function InsertRowLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowLeftOutlinedSvg
  }));
};

InsertRowLeftOutlined.displayName = 'InsertRowLeftOutlined';
export default React.forwardRef(InsertRowLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InsertRowLeftOutlined.js
// module id = 2975
// module chunks = 0